import React from "react";
import "../styles.css";

type CoachMarkStepSevenProps = {
  visible: boolean;
  onNext: () => void;
};

const CoachMarkStepSeven = ({ visible, onNext }: CoachMarkStepSevenProps) => {
  if (!visible) return null;

  return (
    <div
      className="coachmark-overlay coachmark-overlay-centered"
      role="dialog"
      aria-modal="true"
      aria-label="Coach mark step seven"
    >
      <div className="coachmark-step-seven-card">
        <div className="coachmark-step-seven-inner">
            <img
            src={require("../../assets/u4uOnb.png")}
            alt="U4U"
            className="coachmark-step-seven-logo"
          />
          <img
            src={require("../../assets/ic_housepledge.png")}
            alt="House pledge"
            className="coachmark-step-seven-title"
          />

          <img
            src={require("../../assets/freepik_talk.png")}
            alt="House pledge illustration"
            className="coachmark-step-seven-illustration"
          />

          <div className="coachmark-step-seven-text">
           U4U is a safe space! No judging - I’ll respect our unique differences, interests, and issues.
          </div>

          <button
            type="button"
            onClick={onNext}
            className="coachmark-step-seven-next"
            aria-label="Count me in"
          >
            <span>COUNT ME IN!</span>
            <img
              src={require("../../assets/arrow-left-coach.png")}
              alt=""
              aria-hidden="true"
              className="coachmark-step-seven-next-icon"
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CoachMarkStepSeven;